import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultarCidadaoAutista } from './types';

export const INITIAL_STATE: ConsultarCidadaoAutista = {
	data: null,
	status: 0,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultarCidadaoAutista {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_CIDADAO_AUTISTA_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.CONSULTAR_CIDADAO_AUTISTA_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.CONSULTAR_CIDADAO_AUTISTA_FAILURE: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.CONSULTAR_CIDADAO_AUTISTA_CLEAR: {
				draft.data = INITIAL_STATE.data;
				draft.status = INITIAL_STATE.status;
				break;
			}

			default:
		}
		return draft;
	});
}
